import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const DEFAULT_IMAGE_CLASS_NAME = "max-h-[46px] max-w-[112px]";

const PartnerLogoTile = ({ logo, isDuplicate }) => (
  <li className="shrink-0 pr-3">
    <div className="flex h-[74px] w-[148px] items-center justify-center overflow-hidden rounded-xl border border-cfLandingPartnerTileBorder bg-cfLandingPartnerTileBg px-4 shadow-[0_10px_28px_rgba(17,11,130,0.28)] backdrop-blur-[6px]">
      <img
        src={logo.src}
        alt={isDuplicate ? "" : logo.alt}
        aria-hidden={isDuplicate ? "true" : undefined}
        decoding="async"
        className={`object-contain ${
          logo.imageClassName || DEFAULT_IMAGE_CLASS_NAME
        }`}
      />
    </div>
  </li>
);

const PartnerLogoMarquee = ({ logos, durationSeconds }) => {
  const { t } = useTranslation();

  return (
    <div
      role="region"
      aria-label={t("authPages:landing_partners_label")}
      className="cf-marquee-mask group relative overflow-hidden"
    >
      <ul
        style={{ "--cf-marquee-duration": `${durationSeconds}s` }}
        className="m-0 flex w-max list-none animate-marquee p-0 group-hover:[animation-play-state:paused] motion-reduce:animate-none"
      >
        {logos.map((logo) => (
          <PartnerLogoTile key={logo.alt} logo={logo} isDuplicate={false} />
        ))}
        {logos.map((logo) => (
          <PartnerLogoTile
            key={`duplicate-${logo.alt}`}
            logo={logo}
            isDuplicate
          />
        ))}
      </ul>
    </div>
  );
};

const logoShape = PropTypes.shape({
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  imageClassName: PropTypes.string,
});

PartnerLogoTile.propTypes = {
  logo: logoShape.isRequired,
  isDuplicate: PropTypes.bool,
};

PartnerLogoTile.defaultProps = {
  isDuplicate: false,
};

PartnerLogoMarquee.propTypes = {
  logos: PropTypes.arrayOf(logoShape).isRequired,
  durationSeconds: PropTypes.number,
};

PartnerLogoMarquee.defaultProps = {
  durationSeconds: 55,
};

export default PartnerLogoMarquee;
